import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Client } from '@/types/client';
import Grid, { itemText } from '@/components/molecules/section/Grid';
import Container from '@/components/molecules/section/Container';

const View: React.FC<{ client: Client }> = ({ client }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const items = [
    itemText(t('client.tradesy.tradesy_id'), client.tradesy?.id),
    itemText(t('client.tradesy.first_name'), client.tradesy?.firstName),
    itemText(t('client.tradesy.last_name'), client.tradesy?.lastName),
    itemText(t('client.tradesy.email'), client.tradesy?.email),
    itemText(t('client.tradesy.phone_number'), client.tradesy?.phoneNumbers),
    itemText(t('client.tradesy.post_address'), client.tradesy?.addresses?.trim()),
    itemText(
      t('client.tradesy.is_migrated'),
      client.tradesy?.isMigrated === '1' ? `✅ ${t('migrated')}` : `❌ ${t('nonmigrated')}`,
    ),
    itemText(t('client.tradesy.seller_migration_status'), client.tradesy?.sellerMigrationStatus),
    itemText(t('client.tradesy.planned_seller_migration_date'), client.tradesy?.plannedSellerMigrationDate),
    itemText(t('client.tradesy.seller_migration_date'), client.tradesy?.sellerMigrationDate),
    itemText(t('client.tradesy.listings_on_tradesy'), client.tradesy?.activeListingsOnTradesy),
    itemText(t('client.tradesy.eligible_listings'), client.tradesy?.eligibleListings),
    itemText(t('client.tradesy.listed_on_vc'), client.tradesy?.publishedListingsOnVC),
    itemText(t('client.tradesy.cashable_balance'), client.tradesy?.cashableBalance),
    itemText(t('client.tradesy.noncashable_balance'), client.tradesy?.noncashableBalance),
  ];

  return (
    <Container
      title={t('client.tradesy.title')}
      actions={[]}
      handler={{ open, setOpen }}
      testId="tradesy_info"
    >
      <Grid
        column={5}
        items={items}
      />
    </Container>
  );
};

export default View;
